module.exports = __webpack_public_path__ + "images/map02.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/map02.png
// module id = 133
// module chunks = 0